import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';

const Hero = ({ title, link }) => {
  return (
    <section className="bg_house_price bg_img bg-dark">
        <div className="container">
            <div className="row py-5">
                <div className="col-md-12">
                    <h4 className="text-center text-white">{title}</h4>
                    <div className="text-center text-white p-3">
                        <NavLink to="/" className="text-decoration-none text-white mx-3">Home</NavLink>
                        <FontAwesomeIcon icon={faLongArrowAltRight} />
                        <NavLink to={`/${link}`} className="text-decoration-none text-white mx-3">{title}</NavLink>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Hero
